<template>
  <!-- 子应用容器 -->
  <div id="subapp-viewport">
    <!-- 微前端加载状态 -->
    <el-row>
      <el-col :sm="24" :lg="24" v-if="$root.microError">
        <el-result icon="error" title="遇到错误" :subTitle="$root.microError">
          <template slot="extra">
            <el-button type="primary" size="medium" @click="reload()"
              >刷新页面</el-button
            >
          </template>
        </el-result>
      </el-col>

      <div v-else-if="$root.microLoading" class="loading-container">
        <div class="loading-spinner">
          <div class="spinner"></div>
          <p class="loading-text">微应用加载中...</p>
        </div>
      </div>
      <div v-else>
        <p>请检查微应用是否正确启动</p>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Container",
  methods: {
    // 刷新页面
    reload() {
      window.location.reload();
    },
  },
};
</script>
<style scoped>
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  width: 100%;
}

.loading-spinner {
  text-align: center;
}

.spinner {
  width: 40px;
  height: 40px;
  margin: 0 auto 20px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #409eff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-text {
  color: #606266;
  font-size: 14px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
